import React from "react";
import Card from "../ui/card/Card";
import Stack from "../ui/Stack";
import CardTitle from "../ui/card/CardTitle";
import CardList from "../ui/card/CardUlLIst";

const DashboardCards = ({ data }) => {
    return (
        <>
            <div className="row row-gap-4">
                {data.map((item) => {
                    return (
                        <div className="col-md-6 col-xl-3" key={item.id}>
                            <Card className="border-0 h-100" cardBgColor={item.cardBgColor}>
                                <Stack className="flex-column gap-4 h-100">
                                    <CardTitle title={item.title} subTitle={item.subTitle} icon={item.icon} link={item.link}
                                        iconBgColor={item.iconBgColor} />
                                    <CardList className="mb-0 mt-auto" items={item.items} />
                                </Stack>
                            </Card>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
export default DashboardCards;
